import React, { useState, useRef, useEffect } from "react";
import { getUserInfo, removeCookies, getCookies } from "../../../utils/configuration";
import { TOKEN_KEY, REFRESH_TOKEN_KEY, URL_RETURN_KEY, FCM_TOKEN } from "../../../config/common";
import SwitchLanguage from "../switchLanguage";
import { UrlCollection } from "../../../common/url-collection";
import history from "../../../common/history";
import { MediaUrl } from "../../../utils/configuration";
import { useResponsive } from "../../../hooks/mediaQuery";
import { Menu } from "lucide-react";
import { IconButton } from "@mui/material";
import { useUserInfo } from "../../../hooks/useUserInfo";

const Topbar: React.FC<{ pageTitle: string | undefined, toggleDrawer: (newOpen: boolean) => () => void }> = ({ pageTitle, toggleDrawer }) => {
    const { isLg, isXl } = useResponsive();
    const isMobile = !isLg && !isXl;
    const { userInfo: user, handleUnregisterNotification } = useUserInfo();

    const [dropdownOpen, setDropdownOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);

    // Click outside để đóng dropdown
    useEffect(() => {
        const token = getCookies(TOKEN_KEY);
        const user = getUserInfo();
        if (!token || !user || !user.userRole) {
            window.location.href = "/login";
        }
    }, []);

    useEffect(() => {
        if (dropdownOpen) {
            const handleClickOutside = (event: MouseEvent) => {
                if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                    setDropdownOpen(false);
                }
            };
            document.addEventListener("mousedown", handleClickOutside);
            return () => document.removeEventListener("mousedown", handleClickOutside);
        }
    }, [dropdownOpen])
    const handleLogout = async () => {
        await handleUnregisterNotification();
        removeCookies(FCM_TOKEN);
        removeCookies("isShowDialog");
        removeCookies("isLockScreen");
        removeCookies(TOKEN_KEY);
        removeCookies(REFRESH_TOKEN_KEY);
        removeCookies(URL_RETURN_KEY);
        history.push("/login");
    };

    return (
        <header className={`bg-white border-b border-gray-200 shadow ${isMobile ? "px-2 py-2" : "px-6 py-4"} flex items-center justify-between`}>
            <h1 className="text-xl font-semibold text-gray-800">{pageTitle}</h1>
            {!isMobile ? (
                <div className="flex items-center gap-6">
                    <SwitchLanguage />
                    <div className="relative" ref={dropdownRef}>
                        <button
                            onClick={() => setDropdownOpen(!dropdownOpen)}
                            className="flex items-center gap-2 focus:outline-none"
                        >
                            <span className="text-sm text-gray-600">
                                <span className="font-semibold text-gray-800">{user?.fullName}</span>
                            </span>
                            <img
                                src={user?.avatarUrl ? MediaUrl + user.avatarUrl : '/assets/images/user-avatar.png'}
                                alt="avatar"
                                className="w-8 h-8 rounded-full border"
                                onError={(e) => {
                                    e.currentTarget.onerror = null;
                                    e.currentTarget.src = '/assets/images/user-avatar.png';
                                }}
                            />
                        </button>

                        {dropdownOpen && (
                            <div className="absolute right-0 mt-2 w-48 bg-white border border-gray-200 rounded-md shadow-lg z-10">
                                <button
                                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                                    onClick={() => history.push(UrlCollection.UserInfo)}
                                >
                                    Thông tin
                                </button>
                                <button
                                    className="block w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-gray-100"
                                    onClick={handleLogout}
                                >
                                    Đăng xuất
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            ) : (
                <div>
                    <IconButton onClick={toggleDrawer(true)}>
                        <Menu />
                    </IconButton>
                </div>
            )}
        </header>
    );
};

export default Topbar;
